import { Nomenclature } from "./nomenclature";

export class OtherKpModel {
  constructor() { }
  id: string;
  dateCreate: string;
  region: string;
  agreementStatus: string;
  comment: string;
  amountPosition: number;
  typeId: number;
  statusKP: string;
  kamId: string;
  customerId: string;
  distributorId: string;
  kamName: string;
  customerName: string;
  distributorName: string;
  regionName: string;
  regionId: string;
  inn: string;
  distributerParticipantName: string
  distributerParticipant: string
  nomenclatureList: Array<Nomenclature> = new Array<Nomenclature>();
  summKp: number;
  margeTotal: number;
  margePercentTotal: number;
  nmc: number;
  typeName: string;
  iSReplaceCompetitors: number = 0;

  dateAuction: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/other-kp-model.ts